import { render, staticRenderFns } from "./LoyaltiyRewardsPublic.vue?vue&type=template&id=7c376d42&scoped=true"
import script from "./LoyaltiyRewardsPublic.vue?vue&type=script&lang=js"
export * from "./LoyaltiyRewardsPublic.vue?vue&type=script&lang=js"
import style0 from "./LoyaltiyRewardsPublic.vue?vue&type=style&index=0&id=7c376d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c376d42",
  null
  
)

export default component.exports